import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=bee8fffc&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=bee8fffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee8fffc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bee8fffc')) {
      api.createRecord('bee8fffc', component.options)
    } else {
      api.reload('bee8fffc', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=bee8fffc&scoped=true&", function () {
      api.rerender('bee8fffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-268mzVIqTumMG/JS/comp/Voucher.vue"
export default component.exports